module.exports = __webpack_public_path__ + "img/logo@2x.0783805a.png";